import React from 'react'
import {connect} from 'react-redux'
import 'moment/locale/pt-br'
import '../../../css/components/react-datepicker.css';
import pt from 'date-fns/locale/pt';
import Titulo from '../../comum/Titulo';
import Autorizacao from '../../../security/Autorizacao';
import {
    getAdminEmpresa,
    getFinanceiroAgencia, getFinanceiroCaixa,
    getFinanceiroEmpresa,
    PERFIL_ADMIN,
} from '../../../security/securityContext';
import {registerLocale, setDefaultLocale} from 'react-datepicker';
import DatePicker from 'react-datepicker/es';
import { buscarResumoFinanceiro, buscarResumoFinanceiroItinerario } from '../../../actions/resumo-financeiro/buscarResumoFinanceiro';
import filtrarResumoFinanceiro from '../../../actions/resumo-financeiro/filtrarResumoFinanceiro';
import moment from 'moment';
import limparResumoFinanceiro from '../../../actions/resumo-financeiro/limparResumoFinanceiro';
import elementosPaginaAtual from '../../../util/elementosPaginaAtual';
import CabecalhoRodapeTabela from '../../comum/CabecalhoRodapeTabela';
import OpcoesPaginacaoResumoFinanceiro from './OpcoesPaginacaoResumoFinanceiro';
import SetasPaginacaoResumoFinanceiro from './SetasPaginacaoResumoFinanceiro';
import alterarRegistrosPorPagina from '../../../actions/resumo-financeiro/alterarRegistrosPorPaginaResumoFinanceiro';
import determinarPaginaAtual from '../../../actions/resumo-financeiro/determinarPaginaAtualResumoFinanceiro';
import {formatarReal, realParaNumberExportacao} from '../../../util/numberUtil';
import ExportarCsv from '../../comum/ExportarCSV';
import {renderFieldSelect, requiredSelect, renderFieldCheck} from '../../../util/inputs';
import {Field, reduxForm} from 'redux-form';
import {URL} from '../../../util/ambienteActions';
import axios from 'axios';
import {SLOW_REQUEST_CONFIG} from '../../../util/loadingUtil';

const cabecalhoExportacao = (label) => [label, 'R$ - Total de Vendas(+)', 'Quantidade de Bilhetes', 'R$ - Total de Desconto(-)', 'R$ - Total de imposto(-)', 'R$ - Total de seguro(-)',
    'R$ - Total de Comissão(-)', 'R$ - Total de Vendas no Cartão(-)', 'R$ - Total de Vendas no PIX(-)', 'R$ - Total de Cancelamentos(-)', 'R$ - Total de Multa de Cancelamento(+)', 'R$ - Total de Líquido'];

const cabecalhoExportacaoTipoVendedorEmpresa = () => ['Vendedor/Plataforma', 'Empresa', 'R$ - Total de Vendas(+)', 'Quantidade de Bilhetes', 'R$ - Total de Desconto(-)', 'R$ - Total de imposto(-)', 'R$ - Total de seguro(-)',
    'R$ - Total de Comissão(-)', 'R$ - Total de Vendas no Cartão(-)', 'R$ - Total de Vendas no PIX(-)', 'R$ - Total de Cancelamentos(-)', 'R$ - Total de Multa de Cancelamento(+)', 'R$ - Total de Líquido'];

const cabecalhoExportacaoTipoVendedorEmpresaEncomenda = () => ['Vendedor', 'Empresa', 'R$ - Total de Vendas(+)', 'Quantidade de Encomendas', 'R$ - Total de imposto(-)',
    'R$ - Total de Comissão(-)', 'R$ - Total de Cancelamentos(-)', 'R$ - Total de Líquido'];

const cabecalhoExportacaoTipoEstado = () => ['Estado', 'R$ - Total de Vendas(+)', 'Quantidade de Bilhetes', 'R$ - Total de Desconto(-)', 'R$ - Total de imposto(-)', 'R$ - Total de seguro(-)',
    'R$ - Total de Comissão(-)', 'R$ - Total de Líquido'];

const cabecalhoExportacaoTipoItinerario = (ehEncomenda) => ['Itinerário', 'Empresa', 'Prefixo/Rota', 'Data Itinerário', 'Prestador', 'Nome do Veículo', 'Quilometragem(Km)', ehEncomenda ? 'Total Encomendas' : 'Total Passageiros', 'R$ - Total de Vendas(+)',
    'R$ - Total de Imposto(-)', 'R$ - Total de Comissão(-)', 'R$ - Total de Entradas(+)', 'R$ - Total de Saídas(-)', 'R$ - Total Líquido(+)'];

const cabecalhoExportacaoEncomenda = (label) => [label, 'R$ - Total de Vendas(+)', 'Quantidade de Encomendas', 'R$ - Total de imposto(-)',
'R$ - Total de Comissão(-)', 'R$ - Total de Cancelamentos(-)', 'R$ - Total de Líquido'];

registerLocale('pt', pt);
setDefaultLocale('pt');

export class PainelResumoFinanceiro extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tipoResumo: null,
            tipos: [],
            ehEncomenda: false
        };

        this.submeterBusca = this.submeterBusca.bind(this);

    }


    componentDidMount() {
        this.props.alterarRegistrosPorPagina(50);
        this.props.determinarPaginaAtual(1);
        this.props.limparResumoFinanceiro();
        this.recuperarTiposPrecos();
    }

    recuperarTiposPrecos() {
        const url = `${URL}/resumo-financeiro/tipos/${this.props.empresaSelecionada.id}`;
        axios.get(url, SLOW_REQUEST_CONFIG).then((response) => {
            if (response != null) {
                this.setState({tipos: response.data})
            }
        })
    }

    submeterBusca(event) {
        this.props.alterarRegistrosPorPagina(50);
        this.props.determinarPaginaAtual(1);
        this.props.filtrarResumoFinanceiro(this.props.resumoFinanceiroInicial, event.target.value);
    }

    recuperarDadosExportacao() {
        const itens = [];
        const ehEncomenda = this.state.ehEncomenda;
        if (this.props.resumoFinanceiro && this.props.resumoFinanceiro.length > 0) {
            this.props.resumoFinanceiro.forEach((fechamentoConsolidado) => {
                let valores = [];
                if (this.state.tipoResumo === 'VENDEDOR_EMPRESA') {
                    if(ehEncomenda) {
                        valores = [fechamentoConsolidado.nome, fechamentoConsolidado.nomeEmpresa, realParaNumberExportacao(fechamentoConsolidado.totalVendas), fechamentoConsolidado.quantidadeEncomendas,
                            realParaNumberExportacao(fechamentoConsolidado.totalImposto), realParaNumberExportacao(fechamentoConsolidado.totalComissao),
                            realParaNumberExportacao(fechamentoConsolidado.totalCancelamento), realParaNumberExportacao(fechamentoConsolidado.totalLiquido)];
                    } else {
                        valores = [fechamentoConsolidado.nome, fechamentoConsolidado.nomeEmpresa, realParaNumberExportacao(fechamentoConsolidado.totalVendas), fechamentoConsolidado.qtdReservas,
                            realParaNumberExportacao(fechamentoConsolidado.totalDesconto), realParaNumberExportacao(fechamentoConsolidado.totalImposto), realParaNumberExportacao(fechamentoConsolidado.totalTarifaSeguro),
                            realParaNumberExportacao(fechamentoConsolidado.totalComissao), realParaNumberExportacao(fechamentoConsolidado.totalRecebidoCartao),
                            realParaNumberExportacao(fechamentoConsolidado.totalCancelamento), realParaNumberExportacao(fechamentoConsolidado.totalCustoCancelamento),
                            realParaNumberExportacao(fechamentoConsolidado.totalDeposito)];
                    }
                } else if (this.state.tipoResumo === 'ESTADO') {
                    if(ehEncomenda) {
                        valores = [fechamentoConsolidado.nome, realParaNumberExportacao(fechamentoConsolidado.totalVendas), fechamentoConsolidado.quantidadeEncomendas,
                            realParaNumberExportacao(fechamentoConsolidado.totalImposto), realParaNumberExportacao(fechamentoConsolidado.totalComissao),
                            realParaNumberExportacao(fechamentoConsolidado.totalCancelamento), realParaNumberExportacao(fechamentoConsolidado.totalLiquido)];
                    } else {
                        valores = [fechamentoConsolidado.nome, realParaNumberExportacao(fechamentoConsolidado.totalVendas), fechamentoConsolidado.qtdReservas,
                            realParaNumberExportacao(fechamentoConsolidado.totalDesconto), realParaNumberExportacao(fechamentoConsolidado.totalImposto), realParaNumberExportacao(fechamentoConsolidado.totalTarifaSeguro),
                            realParaNumberExportacao(fechamentoConsolidado.totalComissao),
                            realParaNumberExportacao(fechamentoConsolidado.totalDeposito)];
                    }
                } else if (this.ehItinerarioOuItinerarioEmpresa(this.state.tipoResumo)) {
                    valores = [fechamentoConsolidado.id, fechamentoConsolidado.nomeEmpresa, fechamentoConsolidado.rota, moment(fechamentoConsolidado.dataItinerario).format('DD/MM/YYYY'), fechamentoConsolidado.prestador,
                        fechamentoConsolidado.nomeVeiculo, fechamentoConsolidado.quilometragem, ehEncomenda ? fechamentoConsolidado.totalEncomendas : fechamentoConsolidado.totalPassageiros, realParaNumberExportacao(fechamentoConsolidado.totalVendas),
                        realParaNumberExportacao(fechamentoConsolidado.totalImpostoRetido), realParaNumberExportacao(fechamentoConsolidado.totalComissao), realParaNumberExportacao(fechamentoConsolidado.totalEntradas),
                        realParaNumberExportacao(fechamentoConsolidado.totalSaidas), realParaNumberExportacao(this.calcularTotalLiquidoEntradaSaida(fechamentoConsolidado))];
                } else {
                    if(ehEncomenda) {
                        valores = [fechamentoConsolidado.nome, realParaNumberExportacao(fechamentoConsolidado.totalVendas), fechamentoConsolidado.quantidadeEncomendas,
                            realParaNumberExportacao(fechamentoConsolidado.totalImposto), realParaNumberExportacao(fechamentoConsolidado.totalComissao),
                            realParaNumberExportacao(fechamentoConsolidado.totalCancelamento), realParaNumberExportacao(fechamentoConsolidado.totalLiquido)];
                    } else {
                        valores = [fechamentoConsolidado.nome, realParaNumberExportacao(fechamentoConsolidado.totalVendas), fechamentoConsolidado.qtdReservas,
                            realParaNumberExportacao(fechamentoConsolidado.totalDesconto), realParaNumberExportacao(fechamentoConsolidado.totalImposto), realParaNumberExportacao(fechamentoConsolidado.totalTarifaSeguro),
                            realParaNumberExportacao(fechamentoConsolidado.totalComissao), realParaNumberExportacao(fechamentoConsolidado.totalRecebidoCartao),
                            realParaNumberExportacao(fechamentoConsolidado.totalCancelamento), realParaNumberExportacao(fechamentoConsolidado.totalCustoCancelamento),
                            realParaNumberExportacao(fechamentoConsolidado.totalDeposito)];
                    }
                }

                itens.push(valores.concat());
            });
        }
        let cabecalho = cabecalhoExportacao(this.recuperarLabel());

        if(ehEncomenda) {
            cabecalho = cabecalhoExportacaoEncomenda(this.recuperarLabel());
        }

        if (this.state.tipoResumo === 'VENDEDOR_EMPRESA') {
            if(ehEncomenda) {
                cabecalho = cabecalhoExportacaoTipoVendedorEmpresaEncomenda()
            } else {
                cabecalho = cabecalhoExportacaoTipoVendedorEmpresa()
            }
        }
        if (this.state.tipoResumo === 'ESTADO') {
            cabecalho = cabecalhoExportacaoTipoEstado()
        }
        if(this.ehItinerarioOuItinerarioEmpresa(this.state.tipoResumo)) {
            cabecalho = cabecalhoExportacaoTipoItinerario(ehEncomenda)
        }
        return (
            [[this.state.tipoResumo !== 'EMPRESA' && this.state.tipoResumo !== 'VENDEDOR_EMPRESA'
            && this.state.tipoResumo !== 'VENDEDOR_TODAS_EMPRESAS' ? 'Empresa: ' + this.props.empresaSelecionada.nomeFantasia : '']].concat([['Período: ' + moment(this.state.dataInicio)
                .format('DD/MM/YYYY') + ' - ' + moment(this.state.dataFim)
                .format('DD/MM/YYYY')]]
                .concat([['Emissor: ' + this.props.nomeUsuario]]
                    .concat([cabecalho].concat(itens)))))
    }

    recuperarLabel() {
        switch (this.state.tipoResumo) {
            case 'EMPRESA': {
                return 'Empresa'
            }
            case 'AGENCIA': {
                return 'Agência'
            }
            case 'ESTADO': {
                return 'Estado'
            }
            case 'ITINERARIO': {
                return 'Itinerário'
            }
            case 'ITINERARIO_EMPRESAS': {
                return 'Itinerário'
            }
            default: {
                return 'Vendedor/Plataforma';
            }

        }
    }

    calcularTotalLiquidoEntradaSaida(fechamentoConsolidado) {
        if (fechamentoConsolidado) {
            const valorLiquido = Number(fechamentoConsolidado.totalLiquido)
            const valorEntrada = Number(fechamentoConsolidado.totalEntradas)
            const valorSaida = Number(fechamentoConsolidado.totalSaidas)
            return (valorLiquido + valorEntrada - valorSaida).toString()
        }
        return 0;
      }

    exibirRelatorio() {
        const ehEncomenda = this.state.ehEncomenda;
        if (this.props.resumoFinanceiro && this.props.resumoFinanceiro.length) {
            const resumoFinanceiro = elementosPaginaAtual(
                this.props.resumoFinanceiro,
                this.props.paginaAtual,
                this.props.registrosPorPagina
            );
            return (
                <React.Fragment>
                    <CabecalhoRodapeTabela OpcoesPaginacao={OpcoesPaginacaoResumoFinanceiro}
                                           BotoesPaginacao={SetasPaginacaoResumoFinanceiro}
                                           empresas={this.props.resumoFinanceiro}>
                        <div className="d-flex flex-row-reverse mb-4 mr-4">
                            <div className='pull-right'>
                                <ExportarCsv dadosCsv={this.recuperarDadosExportacao()}
                                             nomeArquivo={`resumo-financeiro-${moment(this.state.dataInicio)
                                                 .format('DD/MM/YYYY') + '-' + moment(this.state.dataFim)
                                                 .format('DD/MM/YYYY')}.csv`}/>
                            </div>
                        </div>
                        <div className='table-responsive'>
                            <table className="table table-striped table-bordered vx-report-table">
                                <thead>
                                <tr style={{borderBottom: '1px solid #c8ced3'}}>
                                    <th colSpan={8} style={{borderRight: '0'}}>
                                        {this.state.tipoResumo !== 'EMPRESA' && this.state.tipoResumo !== 'VENDEDOR_EMPRESA'
                                        && this.state.tipoResumo !== 'VENDEDOR_TODAS_EMPRESAS'
                                            ?
                                            <React.Fragment><strong>Empresa: </strong>{this.props.empresaSelecionada.nomeFantasia}
                                            </React.Fragment> : ''}
                                        <br/>
                                        <strong> Período: </strong>{moment(this.state.dataInicio)
                                        .format('DD/MM/YYYY') + ' - ' + moment(this.state.dataFim)
                                        .format('DD/MM/YYYY')}
                                        <br/>
                                        <strong>Emissor: </strong>{this.props.nomeUsuario}
                                    </th>
                                </tr>
                                <tr className='border-top-1'>
                                    <th scope='col'>{this.recuperarLabel()}</th>
                                    {this.state.tipoResumo === 'VENDEDOR_EMPRESA' ?
                                        <th scope="col">Empresa</th> : null}
                                    <th scope="col">Total de Vendas(+)</th>
                                    <th scope="col">{ehEncomenda ? 'Quantidade de Encomendas' : 'Quantidade de Bilhetes'}</th>
                                    {!ehEncomenda ?
                                    <th scope="col">Total de Desconto(-)</th> : null}
                                    <th scope="col">Total de imposto(-)</th>
                                    <th scope="col">Total de seguro(-)</th>
                                    <th scope="col">Total de Comissão(-)</th>
                                    {this.state.tipoResumo !== 'ESTADO' && !ehEncomenda ?
                                        <th scope="col">Total de Vendas no Cartão(-)</th> : ''}
                                    {this.state.tipoResumo !== 'ESTADO' && !ehEncomenda ?
                                        <th scope="col">Total de Vendas no PIX(-)</th> : ''}
                                    {this.state.tipoResumo !== 'ESTADO' || ehEncomenda ?
                                        <th scope="col">Total de Cancelamentos(-)</th> : ''}
                                    {this.state.tipoResumo !== 'ESTADO' && !ehEncomenda ?
                                        <th scope="col">Total de Multa de Cancelamento(+)</th> : ''}
                                    <th scope="col">Total de Líquido</th>
                                </tr>
                                </thead>
                                <tbody>
                                {resumoFinanceiro.map(fechamentoConsolidado =>
                                    <tr key={`relatorio-fechamento-${fechamentoConsolidado.id}`}>
                                        <td>
                                            <span>{fechamentoConsolidado.nome}</span>
                                        </td>
                                        {this.state.tipoResumo === 'VENDEDOR_EMPRESA' ? <td>
                                            <span>{fechamentoConsolidado.nomeEmpresa}</span>
                                        </td> : null}
                                        <td>
                                            <span>{formatarReal(fechamentoConsolidado.totalVendas)}</span>
                                        </td>
                                        <td>
                                            <span>{ehEncomenda ? fechamentoConsolidado.quantidadeEncomendas : fechamentoConsolidado.qtdReservas}</span>
                                        </td>
                                        {!ehEncomenda ?
                                        <td>
                                            <span>{formatarReal(fechamentoConsolidado.totalDesconto)}</span>
                                        </td> : null}
                                        <td>
                                            <span>{formatarReal(fechamentoConsolidado.totalImposto)}</span>
                                        </td>
                                        <td>
                                            <span>{formatarReal(fechamentoConsolidado.totalTarifaSeguro)}</span>
                                        </td>
                                        <td>
                                            <span>{formatarReal(fechamentoConsolidado.totalComissao)}</span>
                                        </td>
                                        {this.state.tipoResumo !== 'ESTADO' && !ehEncomenda ?
                                            <td>
                                                <span>{formatarReal(fechamentoConsolidado.totalRecebidoCartao)}</span>
                                            </td> : null}
                                        {this.state.tipoResumo !== 'ESTADO' && !ehEncomenda ?
                                            <td>
                                                <span>{formatarReal(fechamentoConsolidado.totalRecebidoPix)}</span>
                                            </td> : null}
                                        {this.state.tipoResumo !== 'ESTADO' || ehEncomenda ? <td>
                                            <span>{formatarReal(fechamentoConsolidado.totalCancelamento)}</span>
                                        </td> : null}
                                        {this.state.tipoResumo !== 'ESTADO' && !ehEncomenda ? <td>
                                            <span>{formatarReal(fechamentoConsolidado.totalCustoCancelamento)}</span>
                                        </td> : null}
                                        <td> {ehEncomenda ?
                                            <span>{formatarReal(fechamentoConsolidado.totalLiquido)}</span> :
                                            <span>{formatarReal(fechamentoConsolidado.totalDeposito)}</span> }
                                        </td>
                                    </tr>)}
                                </tbody>
                            </table>
                        </div>
                    </CabecalhoRodapeTabela>
                </React.Fragment>
            )
        }
        return <div className="alert alert-warning text-center" role="alert">
            Não foram encontrados resultados para os parâmetros informados.
        </div>;
    }

    exibirRelatorioItinerario() {
        const ehEncomenda = this.state.ehEncomenda;
        if (this.props.resumoFinanceiro && this.props.resumoFinanceiro.length) {
            const resumoFinanceiro = elementosPaginaAtual(
                this.props.resumoFinanceiro,
                this.props.paginaAtual,
                this.props.registrosPorPagina
            );
            return (
                <React.Fragment>
                    <CabecalhoRodapeTabela OpcoesPaginacao={OpcoesPaginacaoResumoFinanceiro}
                                           BotoesPaginacao={SetasPaginacaoResumoFinanceiro}
                                           empresas={this.props.resumoFinanceiro}>
                        <div className="d-flex flex-row-reverse mb-4 mr-4">
                            <div className='pull-right'>
                                <ExportarCsv dadosCsv={this.recuperarDadosExportacao()}
                                             nomeArquivo={`resumo-financeiro-${moment(this.state.dataInicio)
                                                 .format('DD/MM/YYYY') + '-' + moment(this.state.dataFim)
                                                 .format('DD/MM/YYYY')}.csv`}/>
                            </div>
                        </div>
                        <div className='table-responsive'>
                            <table className="table table-striped table-bordered vx-report-table">
                                <thead>
                                <tr style={{borderBottom: '1px solid #c8ced3'}}>
                                    <th colSpan={8} style={{borderRight: '0'}}>
                                            <React.Fragment><strong>Empresa: </strong>{this.props.empresaSelecionada.nomeFantasia}
                                            </React.Fragment>
                                        <br/>
                                        <strong> Período: </strong>{moment(this.state.dataInicio)
                                        .format('DD/MM/YYYY') + ' - ' + moment(this.state.dataFim)
                                        .format('DD/MM/YYYY')}
                                        <br/>
                                        <strong>Emissor: </strong>{this.props.nomeUsuario}
                                    </th>
                                </tr>
                                <tr className='border-top-1'>
                                    <th scope='col'>{this.recuperarLabel()}</th>
                                    <th scope="col">Empresa</th>
                                    <th scope="col">Prefixo/Rota</th>
                                    <th scope="col">Data</th>
                                    <th scope="col">Prestador</th>
                                    <th scope="col">Veículo</th>
                                    <th scope="col">Quilometragem(Km)</th>
                                    {ehEncomenda ?
                                    <th scope="col">Total de Encomendas</th> :
                                    <th scope="col">Total de passageiros</th>}
                                    <th scope="col">Total de Vendas(+)</th>
                                    <th scope="col">Total de Imposto(-)</th>
                                    <th scope="col">Total de Comissão(-)</th>
                                    <th scope="col">Total de Entradas(+)</th>
                                    <th scope="col">Total de Saídas(-)</th>
                                    <th scope="col">Total líquido</th>
                                </tr>
                                </thead>
                                <tbody>
                                {resumoFinanceiro.map(fechamentoConsolidado =>
                                    <tr key={`relatorio-fechamento-${fechamentoConsolidado.id}`}>
                                        <td>
                                            <span>{fechamentoConsolidado.id}</span>
                                        </td>
                                        <td>
                                            <span>{fechamentoConsolidado.nomeEmpresa}</span>
                                        </td>
                                        <td>
                                            <span>{fechamentoConsolidado.rota}</span>
                                        </td>
                                        <td>
                                            <span>{moment(fechamentoConsolidado.dataItinerario).format('DD/MM/YYYY')}</span>
                                        </td>
                                        <td>
                                            <span>{fechamentoConsolidado.prestador ? fechamentoConsolidado.prestador : ' - '}</span>
                                        </td>
                                        <td>
                                            <span>{fechamentoConsolidado.nomeVeiculo}</span>
                                        </td>
                                        <td>
                                            <span>{fechamentoConsolidado.quilometragem}</span>
                                        </td>
                                        <td>
                                            <span>{ehEncomenda ? fechamentoConsolidado.totalEncomendas : fechamentoConsolidado.totalPassageiros}</span>
                                        </td>
                                        <td>
                                            <span>{formatarReal(fechamentoConsolidado.totalVendas)}</span>
                                        </td>
                                        <td>
                                            <span>{formatarReal(fechamentoConsolidado.totalImpostoRetido)}</span>
                                        </td>
                                        <td>
                                            <span>{formatarReal(fechamentoConsolidado.totalComissao)}</span>
                                        </td>
                                        <td>
                                            <span>{formatarReal(fechamentoConsolidado.totalEntradas)}</span>
                                        </td>
                                        <td>
                                            <span>{formatarReal(fechamentoConsolidado.totalSaidas)}</span>
                                        </td>
                                        <td>
                                            <span>{formatarReal(this.calcularTotalLiquidoEntradaSaida(fechamentoConsolidado))}</span>
                                        </td>
                                    </tr>)}
                                </tbody>
                            </table>
                        </div>
                    </CabecalhoRodapeTabela>
                </React.Fragment>
            )
        }
        return <div className="alert alert-warning text-center" role="alert">
            Não foram encontrados resultados para os parâmetros informados.
        </div>;
    }

    buscar(values) {
        this.setState({tipoResumo: values.tipoResumo.value});
        this.setState({ehEncomenda: values.encomenda});
        const tipoResumo = values.tipoResumo.value;
        const ehEncomenda = values.encomenda ? values.encomenda : false;
        if(this.ehItinerarioOuItinerarioEmpresa(tipoResumo)) {
            this.props.buscarResumoFinanceiroItinerario(this.props.empresaSelecionada.id, this.state.dataInicio, this.state.dataFim, values.tipoResumo.value, ehEncomenda);
        } else {
            this.props.buscarResumoFinanceiro(this.props.empresaSelecionada.id, this.state.dataInicio, this.state.dataFim, values.tipoResumo.value, ehEncomenda);
        }

    }

    exibirCampoBusca() {
        if (this.props.resumoFinanceiroInicial.length) {
            return (<React.Fragment>
                <div className="input-group mb-3 mt-3">
         <span className="input-group-prepend">
          <button id="btn-campo-busca-processo" type="submit"
                  className="input-group-text bg-white btn-campo-busca" disabled={true}>
            <i className="material-icons">&#xe8b6;</i>
          </button>
        </span>
                    <input className="form-control form-control-lg campo-busca"
                           type="text"
                           id="campo-busca-legitimado"
                           onChange={this.submeterBusca}
                           autoComplete="off"
                           placeholder="Buscar na lista abaixo"/>
                </div>
            </React.Fragment>);
        }
    }

    ehItinerarioOuItinerarioEmpresa(tipoResumo){
        return tipoResumo === 'ITINERARIO' || tipoResumo === 'ITINERARIO_EMPRESAS'
    }

    render() {
        const {
            handleSubmit, submitting, invalid, pristine
        } = this.props;

        return (
            <Autorizacao perfisPermitidos={[
                getFinanceiroAgencia(this.props.empresaSelecionada.id),
                getFinanceiroEmpresa(this.props.empresaSelecionada.id),
                getFinanceiroCaixa(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id),
                PERFIL_ADMIN]}
                empresaSelecionada={this.props.empresaSelecionada}>
                <div className="container-padrao" style={{height: '100%'}}>
                    <Titulo texto="Resumo Financeiro" urlRetorno="/menu-relatorio"/>
                    <form onSubmit={handleSubmit(this.buscar.bind(this))}>
                        <div className="vx-form-panel">
                            <div className='mt-2'>
                                <Field type="checkbox" name='encomenda' component={renderFieldCheck}
                                       label="Encomendas"
                                       css="form-check-input" readOnly={false}
                                       />
                            </div>
                            <div className='row mt-2 mb-3'>
                                <div className='col-md-2 col-12 col-sm-12'>
                                    <span className="label-data">De</span>
                                    <DatePicker
                                        value={this.state.dataInicio}
                                        className='form-control form-control-lg campo-busca data-itinerario'
                                        locale="pt-BR"
                                        onChange={date => {
                                            this.setState({dataInicio: date});
                                            this.props.limparResumoFinanceiro();
                                        }
                                        }
                                        selected={this.state.dataInicio}
                                        dateFormat="dd/MM/yyyy"/>
                                </div>
                                <div className='col-md-2 col-12 col-sm-12'>
                                    <span className="label-data ">Até</span>
                                    <DatePicker
                                        className='form-control form-control-lg campo-busca data-itinerario'
                                        locale="pt-BR"
                                        value={this.state.dataFim}
                                        selected={this.state.dataFim}
                                        onChange={date => {
                                            this.setState({dataFim: date});
                                            this.props.limparResumoFinanceiro();
                                        }
                                        }
                                        dateFormat="dd/MM/yyyy"/>
                                </div>
                                <div className='col-md-6 col-12 col-sm-12'>
                                    <span className="label-dat">Tipo de resumo</span>
                                    <div className='mt-1'>
                                        <Field name='tipoResumo'
                                               onChange={() => this.props.limparResumoFinanceiro()}
                                               options={this.state.tipos}
                                               component={renderFieldSelect}
                                               placeholder='Selecione...' validate={requiredSelect}/>
                                    </div>
                                </div>
                                <div className='col-md-2 col-12 col-sm-12 mt-3 d-flex align-items-center'>
                                    <span className="label-data"> </span>
                                    <button
                                        disabled={invalid || submitting || pristine || !this.state.dataInicio || !this.state.dataFim}
                                        type="submit" className="btn btn-laranja">
                                        Buscar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div className="vx-report-section">
                        {this.exibirCampoBusca()}
                        {this.ehItinerarioOuItinerarioEmpresa(this.state.tipoResumo) ?
                            this.exibirRelatorioItinerario() : this.exibirRelatorio()}
                    </div>
                </div>
            </Autorizacao>
        )
    }
}


export const mapStateToProps = state => (
    {
        empresaSelecionada: state.empresaSelecionada,
        resumoFinanceiro: state.resumoFinanceiro.resumos,
        resumoFinanceiroInicial: state.resumoFinanceiro.resumosInicial,
        nomeUsuario: state.authentication.nomeUsuarioComNumero,
        paginaAtual: state.paginaAtualResumoFinanceiro,
        registrosPorPagina: state.registrosPorPaginaResumoFinanceiro
    });


export default connect(mapStateToProps,
    {
        buscarResumoFinanceiro,
        limparResumoFinanceiro,
        filtrarResumoFinanceiro,
        alterarRegistrosPorPagina,
        determinarPaginaAtual,
        buscarResumoFinanceiroItinerario
    })(reduxForm({
    form: 'formResumoFinanceiro',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
})(PainelResumoFinanceiro));
